import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { elmhurstConfig } from "./data";

export default function ElmhurstPage() {
  return <CityPageTemplate config={elmhurstConfig} />;
}